import axios from "axios";
import { ApiEndpoint } from "./utils";

export const fetchExamResults = (
  token: string,
  userID: number,
  snapshotId: string | null,
) => {
  const endpoint = snapshotId ? "getSnapshotById" : "testResults";
  const payload = snapshotId
    ? { token, snapshot_id: snapshotId }
    : { token, userID };

  return axios.post(
    ApiEndpoint + `wp-json/firstchoiceprep/v1/${endpoint}`,
    payload,
  );
};